



























import Vue from "vue";

// Import External Components
import LayoutSection from "@miele/component-library-vue/src/components/layouts/LayoutSection.vue";
import LayoutFilter from "@miele/component-library-vue/src/components/layouts/LayoutFilter.vue";

// Import Components
import StageContainer from "@/components/containers/StageContainer.vue";
import CollectionContainer from "@/components/containers/CollectionContainer.vue";
import FilterContainerBox from "@/components/containers/FilterContainerBox.vue";
import ResultsHeaderContainer from "@/components/containers/ResultsHeaderContainer.vue";
import LoadMoreButtonContainer from "@/components/containers/LoadMoreButtonContainer.vue";
import ResultsList from "@/components/ResultsList.vue";

// Import Models
import { Tag } from "../models/tag.model";

export default Vue.extend({
  name: "Index",
  components: {
    LayoutFilter,
    StageContainer,
    LayoutSection,
    CollectionContainer,
    FilterContainerBox,
    ResultsHeaderContainer,
    ResultsList,
    LoadMoreButtonContainer,
  },
  mounted() {
    this.$store.dispatch("addLoader");
    this.loadData();
  },
  computed: {
    isLastPage() {
      return this.$store.getters.isLastPage;
    },
    recipes() {
      return this.$store.state.recipes.data;
    },
    translations() {
      return this.$store.state.translations;
    },
    searchState() {
      return this.$store.state.searchParams.search;
    },
    filterState() {
      return this.$store.state.searchParams.tags;
    },
  },
  methods: {
    async loadData() {
      if (this.searchState) {
        await this.$store.dispatch("updateSearchValue", this.searchState);
      } else {
        await this.$store.dispatch("fetchRecipes");
      }

      if (this.filterState) {
        this.filterState.forEach((tag: Tag) => {
          const input = document.getElementById(tag.id) as HTMLInputElement;
          input.checked = true;
        });
      }

      await this.$store.dispatch("fetchGroups");
      await this.$store.dispatch("fetchSlides");
    
      this.$store.dispatch("removeLoader");
      Miele.ModuleLoader.initializeDataLoadModules();
    },
  },
});
